<template>
  <section class="use-cases">
    <header>
      <h2>{{ $t('home.useCasesTitle') }}</h2>
      <p class="subtitle">{{ $t('home.useCasesSubTitle') }}</p>
    </header>
    <div class="container">
      <div class="cases-grid">
        <div class="case-card">
          <div class="case-image">
            <img v-lazy="require('../../../static/images/home/group-mother.png')" :alt="$t('home.giftBabyTitle')">
          </div>
          <h3>{{ $t('home.giftBabyTitle') }}</h3>
          <p>{{ $t('home.giftBabyDesc') }}</p>
        </div>
        <div class="case-card">
          <div class="case-image">
            <img v-lazy="require('../../../static/images/home/group-lovers.png')" :alt="$t('home.giftMyTitle')">
          </div>
          <h3>{{ $t('home.giftMyTitle') }}</h3>
          <p>{{ $t('home.giftMyDesc') }}</p>
        </div>
        <div class="case-card">
          <div class="case-image">
            <img v-lazy="require('../../../static/images/home/group-lifeman.png')" :alt="$t('home.giftFriendTitle')">
          </div>
          <h3>{{ $t('home.giftFriendTitle') }}</h3>
          <p>{{ $t('home.giftFriendDesc') }}</p>
        </div>
      </div>
      <div class="use-cases__cta">
        <button class="btn-usecase-cta" @click="$emit('start')">{{ $t('home.useCasesCta') }} <span class="cta-arrow"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></span></button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'UseCases'
}
</script>

<style lang="scss">
.use-cases {
  padding: 5rem 1.5rem;

  .cases-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    max-width: 960px;
    margin: 0 auto;
  }

  .case-card {
    text-align: center;
    border-radius: 12px;
    background-color: #fff;
    border: 1px solid #e5e7eb;
    overflow: hidden;
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(81, 45, 202, 0.1);
    }

    .case-image {
      width: 100%;
      aspect-ratio: 4 / 3;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s;
      }
    }

    &:hover .case-image img {
      transform: scale(1.05);
    }

    h3 {
      font-size: 1.25rem;
      font-weight: 700;
      color: #1a1a2e;
      margin: 1.25rem 1.25rem 0.5rem;
    }

    p {
      font-size: 0.9375rem;
      color: #6b7280;
      line-height: 1.6;
      padding: 0 1.25rem 1.5rem;
    }
  }

  .use-cases__cta {
    text-align: center;
    margin-top: 2.5rem;
  }

  .btn-usecase-cta {
    display: inline-block;
    padding: 0.875rem 3rem;
    background-color: $el-color-primary;
    color: #fff;
    font-size: 1.0625rem;
    font-weight: 600;
    border-radius: 100px;
    border: none;
    cursor: pointer;
    transition: all 0.25s;

    &:hover {
      background: linear-gradient(to right, #F56368, #ff878b);
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(124, 58, 237, 0.4);
    }
  }
}

@media (max-width: 768px) {
  .use-cases {
    padding: 3.5rem 1rem;

    .cases-grid {
      grid-template-columns: 1fr;
      gap: 1.25rem;
    }
  }
}
</style>
